import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { HomeLink, StatusPage } from "@/components/states";

/** Shown in place of a page the signed-in user's role may not open. */
export function NoPermission() {
  const { t } = useTranslation();
  return (
    <StatusPage
      icon={ShieldAlert}
      title={t("noPermission.title")}
      description={t("noPermission.description")}
      action={<HomeLink />}
    />
  );
}
